<template>
  <div class="l-layout" v-if="token">
    <!--BEGIN HEADER-->
    <header-section></header-section>
    <!--END HEADER-->

    <!--BEGIN CUSTOMERS-->
    <transition name="fade">
      <customers-popup v-if="getCustomersPopup"></customers-popup>
    </transition>

    <!--END CUSTOMERS-->


    <!--BEGIN MAP-->
    <map-section></map-section>
    <!--END MAP-->
  </div>
</template>

<script>
// @ is an alias to /src
import map from '@/components/map/map.vue'
import header from '@/components/partials/header/header.vue'
import customers from '@/components/map/Customers/customers.vue'
import legends from '@/data/legends'
import {mapGetters} from 'vuex'
export default {
  name: 'home',
    metaInfo() {
        return {
            title: this.$t('mapPageTitle'),
        }
    },
  components: {
      'map-section': map,
      'header-section' : header,
      'customers-popup': customers
  },
    computed: {
        ...mapGetters(['getCustomersPopup'])
    },
  data() {
      return {
        token: ''
      }
  },
  created() {
    let token = localStorage.getItem('jwttoken');
    this.token = token ? token : ''
    const legendsList = localStorage.getItem('legendsSelectList')
    if(!legendsList) {
        // first init app set legend list to storage
        let selectedList = legends.map(item => item.id)
        localStorage.setItem('legendsSelectList', JSON.stringify(selectedList));

    }
  }
}
</script>

<style lang="sass" scoped>
  .l-layout
    height: 100%
  .fade-enter-active
    transition: opacity .3s ease
  .fade-enter, .fade-leave-to
    opacity: 0
</style>
